import React from 'react';
import './main.less';

import moment from 'moment';

import { Link } from 'react-router';

function renderImageLink({ child, value }, { row }) {
	return (
		<a
			className='banners-image-link'
			href={row.image}
			target='_blank'
		>
			<img src={row.image} />
		</a>
	);
}

function renderTags({ child, value }, { row }) {
	return (
		<div>
			{value.map((tag) => (
				<div key={tag.id}>{tag.name}</div>
			))}
		</div>
	);
}

function renderActions(_, { row, removeById }) {
	return (
		<div className='action-list'>
			<Link
				className='banners-edit-icon'
				to={`/blog/articles/${row.id}/editor`}
			/>
			<a
				className='remove-icon'
				onClick={() => {
					if (confirm('Delete article?')) {
						removeById(row.id);
					}
				}}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'id'
			},
			column: {}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'language',
			header: {
				title: 'language'
			},
			column: {}
		},
		{
			index: 'image',
			header: {
				title: 'image'
			},
			column: {
				className: 'blog-article-image',
				render: renderImageLink
			}
		},
		{
			index: 'title',
			header: {
				title: 'title'
			},
			column: {}
		},
		{
			index: 'tags',
			header: {
				title: 'tags'
			},
			column: {
				render: renderTags
			}
		},
		{
			index: 'views',
			header: {
				title: 'views'
			},
			column: {}
		},
		{
			index: 'fake_views',
			header: {
				title: 'fake views'
			},
			column: {}
		},
		{
			index: 'preferences.like',
			header: {
				title: 'likes'
			},
			column: {}
		},
		{
			index: 'preferences.dislike',
			header: {
				title: 'dislikes'
			},
			column: {}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article/list/table-initial-data.js